import { setColourMode } from './colour-mode';
import { noscriptHandler } from './no-script';
import { setHeader } from './setup-header';
import { svgDiagrams } from './setup-mermaid-diagrams';
import { sortableTables, wrapTables } from './setup-tables';
import { syncAnimations } from './sync-animations';
import { handlePostImages } from './post-images';
import { importGoat } from './import-goat';
import { handleWebmentions } from './webmentions';
import { setupMathjax } from './setup-mathjax';

/** This file blocks rendering and will run before any dom content loads, call heavy functions in a listener! */

setColourMode();

document.addEventListener('DOMContentLoaded', async function () {
  noscriptHandler();
  wrapTables();
  setHeader();
  sortableTables();
  svgDiagrams();
  syncAnimations();
  handlePostImages();
  importGoat();
  setupMathjax();
  await Promise.all([handleWebmentions()]);
});
